'use client';

import { FC, PropsWithChildren, createContext, useState } from 'react';
import { IAdaptedBasicProduct } from 'commerce/scayle/utils/adapter/types';
import { IProductSizesConfig, IState } from './types';

export const ProductSizesContext = createContext<IProductSizesConfig>({
  triggerForm: null,
  showSizeButtonInHeader: false,
  setIsSizeSelected: () => {},
  setTriggerForm: () => {},
  quantity: 1,
  setQuantity: () => {},
});

export const ProductSizesProvider: FC<
  PropsWithChildren & { product: IAdaptedBasicProduct }
> = ({ children, product }) => {
  const hasSizes = Number(product.size?.length) > 1;
  const [state, setState] = useState<IState>({
    isSizeSelected: false,
    triggerForm: null,
    quantity: 1,
  });

  const setIsSizeSelected: IProductSizesConfig['setIsSizeSelected'] = (value) =>
    setState((prevState) => ({
      ...prevState,
      isSizeSelected: value,
    }));

  const setTriggerForm: IProductSizesConfig['setTriggerForm'] = (triggerForm) =>
    setState((prevState) => ({
      ...prevState,
      triggerForm,
    }));

  const setQuantity = (value: number) =>
    setState((prevState) => ({
      ...prevState,
      quantity: value,
    }));

  return (
    <ProductSizesContext.Provider
      value={{
        triggerForm: state.triggerForm,
        showSizeButtonInHeader: hasSizes ? !state.isSizeSelected : false,
        setIsSizeSelected,
        setTriggerForm,
        quantity: state.quantity,
        setQuantity,
      }}
    >
      {children}
    </ProductSizesContext.Provider>
  );
};
